import { forwardRef } from 'react'

import { useSearchInputModel } from './search-input.model'
import type { SearchInputProps } from './search-input.types'
import { SearchInputView } from './search-input.view'

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>((props, ref) => {
  const searchInputModel = useSearchInputModel(props)
  return <SearchInputView {...props} {...searchInputModel} ref={ref} />
})
